import { render, staticRenderFns } from "./approval_count.vue?vue&type=template&id=b1d7642c"
import script from "./approval_count.vue?vue&type=script&lang=js"
export * from "./approval_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports